// Author LiangGangQiang
// Date 2021-12-08 14:56:39

class SithMesPrdPpHeaderInfoModify {
constructor({
        id = null,
        modifyTypeId = '',
        ppHeaderId = '',
        status = '',
        handleBy = '',
        handleTime = '',
        description = '',
        descriptionShort = '',
        descriptionLong = '',
        attachments = '',
        remark = '',
        rejectReason = '',
        attachmentsList = ''}
= {}) {
    this.id = id;
    this.modifyTypeId = modifyTypeId;
    this.ppHeaderId = ppHeaderId;
    this.status = status;
    this.handleBy = handleBy;
    this.handleTime = handleTime;
    this.description = description;
    this.descriptionShort = descriptionShort;
    this.descriptionLong = descriptionLong;
    this.attachments = attachments;
    this.remark = remark;
    this.rejectReason = rejectReason;
    this.attachmentsList = attachmentsList;
}
}

function newEntity() {
return new SithMesPrdPpHeaderInfoModify();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ppHeaderOrderCode',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.ppHeaderOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.createdByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'modifyTypeName',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.modifyTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '待处理' },
                            { value: '2', text: '已处理' },
                            { value: '3', text: '被拒绝' },
                            { value: '4', text: '已完成' }
            ]
        }
        },
        {
        key: 'handleByName',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.handleByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'handleTime',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.handleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'finishTime',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.finishTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'descriptionShort',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.descriptionShort',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'descriptionLong',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.descriptionLong',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'attachmentsList',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.attachmentsList',
        sortable: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'rejectReason',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.grid.rejectReason',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    modifyTypeIdFilter : '',
    projectCodeFilter : '',
    projectNameFilter : '',
    ppHeaderIdFilter : '',
    ppHeaderOrderCodeFilter : '',
    statusFilter : '',
    createdByNameFilter : '',
    handleByNameFilter : '',
    handleTimeRteFilter : '',
    handleTimeLteFilter : '',
    descriptionFilter : '',
    descriptionShortFilter : '',
    descriptionLongFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'modifyTypeIdFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.modifyTypeId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpHeaderInfoModifyType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectNameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.projectName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ppHeaderIdFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.ppHeaderId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpHeader'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'ppHeaderOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.ppHeaderOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '待处理' },
                { value: '2', text: '已处理' },
                { value: '3', text: '被拒绝' },
                { value: '4', text: '已完成' }
            ]
        }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.createdByName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'handleByNameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.handleByName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'handleTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.handleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'handleTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.handleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.description',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'descriptionShortFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.descriptionShort',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'descriptionLongFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.filter.descriptionLong',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'modifyTypeId',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.entity.modifyTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'sithMesPrdPpHeaderInfoModifyType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'ppHeaderId',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.entity.ppHeaderId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpHeader'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'descriptionShort',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.entity.descriptionShort',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,required: true
            ,entity: 'sithMesPrdPpHeaderInfoModifyOwner'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'descriptionLong',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.entity.descriptionLong',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'attachmentsList',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModify.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachments'
                }
        }
]

export {SithMesPrdPpHeaderInfoModify, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
